import { render } from "./CancelP2PArbitrage.vue?vue&type=template&id=a1530598&scoped=true"
import script from "./CancelP2PArbitrage.vue?vue&type=script&lang=js"
export * from "./CancelP2PArbitrage.vue?vue&type=script&lang=js"

import "./CancelP2PArbitrage.vue?vue&type=style&index=0&id=a1530598&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1530598"]])

export default __exports__